import { useTranslation } from "react-i18next";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangleIcon, FileTextIcon, DollarSignIcon, CheckCircleIcon, RotateCcwIcon, ChevronRightIcon, ServerIcon, RefreshCcwIcon, LinkIcon, SettingsIcon } from 'lucide-react';
import { getTenant } from '../../../theme/tokens';
import { mockBills } from '../../bills/mocks/mockBills';
export function Notifications() {
  const {
    t
  } = useTranslation("notifications");
  const navigate = useNavigate();
  const pendingBills = mockBills.filter(b => b.status === 'pending_approval');
  const recentActivity = [{
    id: 1,
    type: 'payment',
    title: 'Payment received',
    desc: `${getTenant().currency.code} 45,000 from John Doe`,
    time: '10 mins ago',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 2,
    type: 'bill',
    title: 'Bill approved',
    desc: 'INV-2026-003 by Simon Verraest',
    time: '1 hour ago',
    icon: CheckCircleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 3,
    type: 'dispute',
    title: 'New dispute opened',
    desc: `${getTenant().currency.code} 1,538.94 - Fraudulent`,
    time: '3 hours ago',
    icon: AlertTriangleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 4,
    type: 'refund',
    title: 'Refund processed',
    desc: `${getTenant().currency.code} 2,500 to Sarah Smith`,
    time: '5 hours ago',
    icon: RotateCcwIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 5,
    type: 'payment',
    title: 'Payment received',
    desc: `${getTenant().currency.code} 12,400 from Acme Corp`,
    time: 'Yesterday',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }];
  return <div data-id="element-7635" data-mp="16fiswciqgvy2">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-7636" data-mp="16ceekmbk0jto">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-7637" data-mp="3d5ynnes413hi">{t("pages.Notifications.notifications")}</h1>
        <button onClick={() => navigate('/settings')} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors shadow-sm" data-id="element-7638" data-mp="3875kogag8uvl">
          
          <SettingsIcon size={14} data-id="element-7639" data-mp="5s0dd80idd5w" />
          {t("pages.Notifications.manage_preferences")}
        </button>
      </div>

      {/* Notification Center */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-7640" data-mp="fpefe2lopzeo">
        {/* Section: Urgent */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200" data-id="element-7641" data-mp="kmy641zkk4ni">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-7642" data-mp="oo9rfvbeu3pw">
            <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-7643" data-mp="th2tucjeozyt"></span>
            {t("pages.Notifications.urgent_requires_immediate_action")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7644" data-mp="13eh9wb1f3mql">
          <button onClick={() => navigate('/disputes/1')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-7645" data-mp="13fsbc47e4iej">
            
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7646" data-mp="2sw4b8b2u9voj">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-7647" data-mp="2nv6tu0pnl5o3" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-7648" data-mp="2ixybo04i91mu">
              <p className="text-sm font-medium text-gray-900" data-id="element-7649" data-mp="2iyq81d5xf3e6">
                {t("pages.Notifications.dispute_dp20240001_requires_response")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7650" data-mp="3bk9elhfl3emt">
                {t("pages.Notifications.usd_10001_fraudulent_charge")}
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-7651" data-mp="31v9a5iibbr18">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-7652" data-mp="31togdv3toc4f">
                {t("pages.Notifications.due_in_2h")}
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-7653" data-mp="3udn3b4speotz" />
            
          </button>
          <button onClick={() => navigate('/disputes/91')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-7654" data-mp="3pj8zqf3w1be8">
            
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7655" data-mp="3f36s3ttkcaer">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-7656" data-mp="306pjvbgo7bwf" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-7657" data-mp="3550tbl31zke4">
              <p className="text-sm font-medium text-gray-900" data-id="element-7658" data-mp="3sttrzpb286cf">
                {t("pages.Notifications.dispute_dp20240091_requires_response")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7659" data-mp="1mzh6zqjzni5">
                {t("pages.Notifications.usd_153894_duplicate_charge")}
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-7660" data-mp="3o2brt3gv29si">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-7661" data-mp="3o10qdaaw1e4k">
                {t("pages.Notifications.due_in_5h")}
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-7662" data-mp="kfbg1ci006nj" />
            
          </button>
        </div>

        {/* Section: Bills */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-7663" data-mp="20647l7nd18gx">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-7664" data-mp="2eui9ngcycswf">
            <span className="w-2 h-2 rounded-full bg-[#FF4500]" data-id="element-7665" data-mp="29wgpst7pcpjw"></span>
            {t("pages.Notifications.bills_pending_approval")} {pendingBills.length} {t("pages.Notifications.items")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7666" data-mp="1h81eagns4pdb">
          {pendingBills.slice(0, 4).map(bill => <button key={bill.id} onClick={() => navigate(`/bill-detail/${bill.id}`)} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-7667" data-mp="1v714vtuurec4">
            
              <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7668" data-mp="36k3lgowyc3wa">
                <FileTextIcon size={16} className="text-gray-600" data-id="element-7669" data-mp="32jjmrgwqcs81" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-7670" data-mp="1z8dvvi3et6xe">
                <p className="text-sm font-medium text-gray-900" data-id="element-7671" data-mp="2480btzamh19w">
                  {bill.supplierName}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-7672" data-mp="296tppsttmual">
                  {bill.billNumber} {t("pages.Notifications.due")}{' '}
                  {new Date(bill.dueDate).toLocaleDateString('en-GB')}
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-7673" data-mp="1gk8ugha85y1r">
                <p className="text-sm font-semibold text-gray-900" data-id="element-7674" data-mp="1lgpnnpwa72lp">
                  {bill.currency} {bill.amount.toLocaleString()}
                </p>
              </div>
              <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-7675" data-mp="1u9kgtl8h57v4" />
            
            </button>)}
          {pendingBills.length > 4 && <button onClick={() => navigate('/bills')} className="w-full px-5 py-3 text-sm font-medium text-[#FF4500] hover:bg-gray-50 transition-colors text-center" data-id="element-7676" data-mp="xr51ky4tzp87">
            
              {t("pages.Notifications.view_all")} {pendingBills.length} {t("pages.Notifications.pending_bills")}
            </button>}
        </div>

        {/* Section: Recent Activity */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-7677" data-mp="l8suy6ml6olq">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-7678" data-mp="gar2ww76ney4">
            {t("pages.Notifications.recent_activity")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7679" data-mp="bcz89uf5leq8">
          {recentActivity.map(activity => <div key={activity.id} className="flex items-center gap-4 px-5 py-4" data-id="element-7680" data-mp="6ibjrvk5gkbn">
            
              <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${activity.color}`} data-id="element-7681" data-mp="1j8q179me0iz">
              
                <activity.icon size={16} data-id="element-7682" data-mp="3oprkgw8sr57l" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-7683" data-mp="3os4032r313hh">
                <p className="text-sm font-medium text-gray-900" data-id="element-7684" data-mp="3jqeq7qflivuz">
                  {activity.title}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-7685" data-mp="1bjjkkbdoi4ys">{activity.desc}</p>
              </div>
              <span className="text-xs text-gray-400 flex-shrink-0" data-id="element-7686" data-mp="1gg1m72dppn6w">
                {activity.time}
              </span>
            </div>)}
        </div>

        {/* Section: System */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-7687" data-mp="17fvbtpdb93by">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-7688" data-mp="srib6f3a2wb4">
            {t("pages.Notifications.system_status")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7689" data-mp="jr2fhrss0tgt">
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-7690" data-mp="jsn7parmc0bi">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7691" data-mp="ns5ts9v6ehfx">
              <ServerIcon size={16} className="text-gray-600" data-id="element-7692" data-mp="9sml9fygd433" />
            </div>
            <div className="flex-1" data-id="element-7693" data-mp="erpnytqymy7w">
              <p className="text-sm font-medium text-gray-900" data-id="element-7694" data-mp="eqo5i47m79g5">{t("pages.Notifications.api_uptime")}</p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7695" data-mp="3rc3jxvjkxdhj">
                {t("pages.Notifications.all_systems_operational")}
              </p>
            </div>
            <span className="text-sm font-bold text-green-600" data-id="element-7696" data-mp="54wnecqjtma7">99.99%</span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-7697" data-mp="5jzdonxy961">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7698" data-mp="7d8rbpxv7hq">
              <RefreshCcwIcon size={16} className="text-gray-600" data-id="element-7699" data-mp="e2p1jdkjanw0" />
            </div>
            <div className="flex-1" data-id="element-7700" data-mp="95oyzcmw839n">
              <p className="text-sm font-medium text-gray-900" data-id="element-7701" data-mp="nuld9rfjmcip">
                {t("pages.Notifications.last_settlement")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7702" data-mp="ix34q25ftzb8">
                {t("pages.Notifications.completed_successfully")}
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-7703" data-mp="suhiftzz89zu">
              {t("pages.Notifications.0130_am")}
            </span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-7704" data-mp="3175fyfyexb5l">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7705" data-mp="2weue37k43fae">
              <LinkIcon size={16} className="text-gray-600" data-id="element-7706" data-mp="2rh2o4j31238u" />
            </div>
            <div className="flex-1" data-id="element-7707" data-mp="2mhga47fdkiyz">
              <p className="text-sm font-medium text-gray-900" data-id="element-7708" data-mp="2mij2kjscith0">
                {t("pages.Notifications.active_payment_links")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7709" data-mp="3f5vd1vl8faty">
                {t("pages.Notifications.currently_receiving_traffic")}
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-7710" data-mp="3a4plw277zvmj">142</span>
          </div>
        </div>
      </div>
    </div>;
}